<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="12" align="center">
        <ProgressLinear>
          <h3>Aguarde, carregando...</h3>
        </ProgressLinear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Vendedor from "../services/Vendedor";

export default {
  name: "Home",

  components: {
    ProgressLinear: () => import("@/components/ProgressLinear")
  },

  data() {
    return {
      serviceVendedor: new Vendedor()
    };
  },

  methods: {
    ...mapActions("vendedor", ["setVendedor"]),
    ...mapActions("vendedor", ["setEmpresa"]),
    ...mapActions("vendedor", ["setGrupo"]),
    ...mapActions("vendedor", ["setMidia"]),

    async init() {
      try {
        const response = await this.serviceVendedor.getVendedor(
          this.$route.params.uuid
        );
        this.setVendedor(response.data.donoLead);
        this.setEmpresa(response.data.empresaPrincipal);
        this.setGrupo(response.data.grupoPrincipal);
        this.setMidia(response.data.tipoMidia);
        this.$router.push({ name: "Veiculos" });
      } catch (error) {
        console.error(error);
        this.$router.push({ name: "400" });
      }
    }
  },

  mounted() {
    this.init();
  }
};
</script>
